const initSwiperViewedItems = () => {
  const swiperElement = document.querySelector('[data-swiper="viewed-items"]');

  if (!swiperElement) return;

  const swiper = new Swiper(swiperElement, {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      0: {
        slidesPerView: 2.1,
        spaceBetween: 12,
      },
      616: {
        slidesPerView: 3.4,
        spaceBetween: 16,
      },
      1480: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });
};

export {initSwiperViewedItems};
